<div class="wallboardViewSlide" [attr.mid]="moduleKey" [ngStyle]="{ 'background-image': 'url(../Admin/ImageResizer.aspx?imgid=' + backgroundID + '&w=1920&h=1080)' }">
    <div class="wallboardViewSlideContentArea" [ngClass]="hasBackdrop ? 'wallboardViewSlideContentAreaDark' : 'wallboardViewSlideContentAreaLight'">
        <!-- Table's header -->
        <div class="row align-items-center text-left p-2" style="height:120px; border-radius:2px; background-color:rgba(0, 0, 0, 54%)"
             *ngIf="!((selectedGame[0]?.underlyingRule.GameType == 6 || selectedGame[0]?.underlyingRule.GameType == 7) && gameState.DisplayOption == 1) && selectedGame?.length > 0">
            <div class="col-4 d-flex align-items-center">
                <div [ngClass]="selectedGame[0].iconClass" title="{{selectedGame[0].gameTypeName}}" style="width:99px; height:80px; background-size:80px; background-repeat:no-repeat"></div>

                <div class="font-size-32 pl-3 text-truncate">
                    <span> {{selectedGame[0]?.underlyingRule.RuleName}} </span><br />
                    <svg class="font-size-24" style="width:19px; height:19px; fill:#fff"><use href="../App_Themes/clearview-default/icons/utility/time.svg#time"></use></svg>
                    <!--<span class="font-size-24">selectedGame[0].Schedule.EndDate</span>-->
                    <span class="font-size-24">{{selectedGame[0].isActiveText}}</span>
                </div>
            </div>

            <div class="col-3 d-flex flex-column">
                <div class="text-left font-size-24">
                    <span *ngIf="selectedGame[0]?.underlyingRule.GameType != 6 && selectedGame[0]?.underlyingRule.GameType != 7">Grand Prize</span>
                    <span *ngIf="selectedGame[0]?.underlyingRule.GameType == 6 || selectedGame[0]?.underlyingRule.GameType == 7">3-of-a-row Reward</span>
                </div>

                <div class="d-flex w-100 justify-content-between">
                    <div class="d-flex justify-content-center align-items-center font-size-36">
                        <svg class="fill-white mr-2" style="width:40px; height:40px"><use href="../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use></svg>
                        <span *ngIf="selectedGame[0]?.underlyingRule.GameType == 1">{{selectedGame[0].MultiplierMadnessRewards.coins}}</span>
                        <span *ngIf="selectedGame[0]?.underlyingRule.GameType == 2">{{selectedGame[0].TopDogRewards[0].Coins.rewardValue}}</span>
                        <span *ngIf="selectedGame[0]?.underlyingRule.GameType == 3">{{selectedGame[0].BullseyeRewards[0].Coins.rewardValue}}</span>
                        <span *ngIf="selectedGame[0]?.underlyingRule.GameType == 6">{{selectedGame[0].Connect3Rewards.ThreeInRow.coins}}</span>
                        <span *ngIf="selectedGame[0]?.underlyingRule.GameType == 7">{{selectedGame[0].Connect3Rewards.Blackout.coins}}</span>
                        <span *ngIf="selectedGame[0]?.underlyingRule.GameType == 5">{{selectedGame[0].MilestoneRewards[0].Coins.rewardValue}}</span>
                    </div>

                    <div class="d-flex justify-content-center align-items-center font-size-36">
                        <svg class="fill-white mr-2" style="width:40px; height:40px"><use href="../App_Themes/clearview-default/icons/utility/xp.svg#xp"></use></svg>
                        <span *ngIf="selectedGame[0]?.underlyingRule.GameType == 1">{{selectedGame[0].MultiplierMadnessRewards.xp}}</span>
                        <span *ngIf="selectedGame[0]?.underlyingRule.GameType == 2">{{selectedGame[0].TopDogRewards[0].XP.rewardValue}}</span>
                        <span *ngIf="selectedGame[0]?.underlyingRule.GameType == 3">{{selectedGame[0].BullseyeRewards[0].XP.rewardValue}}</span>
                        <span *ngIf="selectedGame[0]?.underlyingRule.GameType == 6">{{selectedGame[0].Connect3Rewards.ThreeInRow.xp}}</span>
                        <span *ngIf="selectedGame[0]?.underlyingRule.GameType == 7">{{selectedGame[0].Connect3Rewards.Blackout.xp}}</span>
                        <span *ngIf="selectedGame[0]?.underlyingRule.GameType == 5">{{selectedGame[0].MilestoneRewards[0].XP.rewardValue}}</span>
                    </div>

                    <div class="d-flex justify-content-center align-items-center" *ngIf="selectedGame[0]?.underlyingRule.GameType != 1">
                        <div *ngIf="selectedGame[0]?.underlyingRule.GameType == 2">
                            <img [src]="'../Admin/ImageResizer.aspx?imgid='+ selectedGame[0].TopDogRewards[0].Badge.rewardValue +'&w=60&h=60'" *ngIf="selectedGame[0].TopDogRewards[0].Badge.rewardValue > 0" />

                            <div class="d-flex justify-content-center align-items-center font-size-36" *ngIf="!(selectedGame[0].TopDogRewards[0].Badge.rewardValue > 0)">
                                <svg class="fill-white mr-2" style="width:40px; height:40px"><use href="../App_Themes/clearview-default/icons/utility/badge.svg#badge"></use></svg>
                                <span>---</span>
                            </div>
                        </div>

                        <div *ngIf="selectedGame[0]?.underlyingRule.GameType == 3">
                            <img [src]="'../Admin/ImageResizer.aspx?imgid='+ selectedGame[0].BullseyeRewards[0].Badge.rewardValue +'&w=60&h=60'" *ngIf="selectedGame[0].BullseyeRewards[0].Badge.rewardValue > 0" />

                            <div class="d-flex justify-content-center align-items-center" *ngIf="!(selectedGame[0].BullseyeRewards[0].Badge.rewardValue > 0)">
                                <svg class="fill-white mr-2" style="width:40px; height:40px"><use href="../App_Themes/clearview-default/icons/utility/badge.svg#badge"></use></svg>
                                <span class="font-size-36">---</span>
                            </div>
                        </div>

                        <div *ngIf="selectedGame[0]?.underlyingRule.GameType == 6">
                            <img [src]="'../Admin/ImageResizer.aspx?imgid='+ selectedGame[0].Connect3Rewards.ThreeInRow.badge +'&w=60&h=60'" *ngIf="selectedGame[0].Connect3Rewards.ThreeInRow.badge > 0" />

                            <div class="d-flex justify-content-center align-items-center" *ngIf="!(selectedGame[0].Connect3Rewards.ThreeInRow.badge > 0)">
                                <svg class="fill-white mr-2" style="width:40px; height:40px"><use href="../App_Themes/clearview-default/icons/utility/badge.svg#badge"></use></svg>
                                <span class="font-size-36">---</span>
                            </div>
                        </div>

                        <div *ngIf="selectedGame[0]?.underlyingRule.GameType == 7">
                            <img [src]="'../Admin/ImageResizer.aspx?imgid='+ selectedGame[0].Connect3Rewards.Blackout.badge +'&w=60&h=60'" *ngIf="selectedGame[0].Connect3Rewards.Blackout.badge > 0" />

                            <div class="d-flex justify-content-center align-items-center" *ngIf="!(selectedGame[0].Connect3Rewards.Blackout.badge > 0)">
                                <svg class="fill-white mr-2" style="width:40px; height:40px; fill:#fff"><use href="../App_Themes/clearview-default/icons/utility/badge.svg#badge"></use></svg>
                                <span class="font-size-36">---</span>
                            </div>
                        </div>

                        <div *ngIf="selectedGame[0]?.underlyingRule.GameType == 5">
                            <img [src]="'../Admin/ImageResizer.aspx?imgid='+ selectedGame[0].MilestoneRewards[0].Badge.rewardValue +'&w=60&h=60'" *ngIf="selectedGame[0].MilestoneRewards[0].Badge.rewardValue > 0" />

                            <div class="d-flex justify-content-center align-items-center" *ngIf="!(selectedGame[0].MilestoneRewards[0].Badge.rewardValue > 0)">
                                <svg class="fill-white mr-2" style="width:40px; height:40px"><use href="../App_Themes/clearview-default/icons/utility/badge.svg#badge"></use></svg>
                                <span class="font-size-36">---</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-3 d-flex align-items-center justify-content-between">
                <div class="w-50 text-center">
                    <div class="font-size-24">Metric</div>

                    <div class="font-size-36" style="line-height:1" *ngIf="selectedGame[0]?.underlyingRule.GameType != 6 && selectedGame[0]?.underlyingRule.GameType != 7">
                        {{selectedGame[0].SelectedMetrics[0].abbrev}}
                    </div>

                    <div class="font-size-36" style="line-height:1" *ngIf="selectedGame[0]?.underlyingRule.GameType == 6 || selectedGame[0]?.underlyingRule.GameType == 7">
                        {{selectedGame[0].SelectedMetrics.length}}
                    </div>
                </div>

                <div class="w-50 text-center">
                    <div class="font-size-24">Qualifier</div>
                    <div class="font-size-36" style="line-height:1">{{selectedGame[0].Qualifier ? selectedGame[0].Qualifier.abbrev : 'None'}}</div>
                </div>
            </div>

            <div class="col-2 text-center d-block align-items-center">
                <div class="font-size-24">Join Players</div>
                <div class="font-size-36">{{totalJoinedParticipants}} / {{totalParticipants}}</div>
            </div>
        </div>

        <!-- END Table's header -->
        <!-- Empty State for MM and TP Disp 1 -->
        <div class="row py-3 mt-3 align-items-center justify-content-center text-left flex-column" style="border-radius:2px; background-color:rgba(0, 0, 0, 54%); height:80%"
             *ngIf="(selectedGame[0]?.underlyingRule.GameType == 1 || selectedGame[0]?.underlyingRule.GameType == 2) && (participantsInfo == null || participantsInfo?.length == 0)">
            <div *ngIf="isSlideDataLoading">
                <div class="font-size-24">Just a moment, we are loading your game stats</div>
            </div>

            <div [hidden]="isSlideDataLoading">
                <div class="font-size-24">No players to show.</div>
                <div class="font-size-24">Check back later.</div>
            </div>
        </div>

        <!-- End Empty State -->
        <!-- Table Multiplier Madness -->
        <div class="row text-left px-4 mt-3 pt-3" style="border-radius:2px; background-color:rgba(0, 0, 0, 54%)" *ngIf="selectedGame[0]?.underlyingRule.GameType == 1 && participantsInfo?.length > 0">
            <div class="col-12">
                <div class="row">
                    <div class="col-5 font-size-24">Agents</div>
                    <div class="col-1 font-size-24 text-center">{{selectedGame[0].Qualifier ? selectedGame[0].Qualifier.abbrev : ''}}</div>
                    <div class="col-2 font-size-24 text-center">{{selectedGame[0].SelectedMetrics[0].name}}</div>
                    <div class="col-2 font-size-24 text-center">Coins</div>
                    <div class="col-2 font-size-24 text-center">XP</div>
                </div>

                <div class="row py-2" [ngStyle]="!last && { 'border-bottom': '1px solid white' }"
                     *ngFor="let participantObject of participantsInfo | orderBy: '-metric' | startOn: currentPage*pageSize:totalPages > 0 | limitTo: pageSize; let last = last">
                    <div class="col-5 d-flex font-size-36 align-items-center">
                        <img class="mr-3" style="height:45px; border-radius:50%; border:1px solid white" [src]="participantObject.ImageSrc" />
                        <div class="text-truncate">{{participantObject.participant.LoginName}}</div>
                    </div>

                    <div class="col-1 text-center d-flex justify-content-center align-items-center">
                        <div *ngIf="selectedGame[0].Qualifier">
                            <svg *ngIf="participantObject.passed" class="icon-32 fill-white"><use href="../App_Themes/clearview-default/icons/utility/checkmark.svg#checkmark"></use></svg>
                            <svg *ngIf="!participantObject.passed" class="icon-32 fill-redRyder"><use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use></svg>
                        </div>
                    </div>

                    <div class="col-2 font-size-36 text-center text-truncate">{{participantObject.metric}}</div>
                    <div class="col-2 font-size-36 text-center text-truncate">{{participantObject.calculatedCoins}}</div>
                    <div class="col-2 font-size-36 text-center text-truncate">{{participantObject.calculatedXP}}</div>
                </div>
            </div>
        </div>

        <!-- END Table Multiplier Madness -->
        <!-- Table Top Dog -->
        <div class="row px-4 mt-3 pt-4 text-left" style="border-radius:2px; background-color:rgba(0, 0, 0, 54%)"
            *ngIf="selectedGame[0]?.underlyingRule.GameType == 2 && gameState.DisplayOption == 0 && participantsInfo?.length > 0">
            <div class="col-12">
                <div class="w-100 px-3 mx-auto" style="background-color:transparent; max-width:90%">
                    <div class="row">
                        <div class="col-4" style="padding-top:30px">
                            <div class="px-1 w-100 text-center pt-5 position-relative" style="background-color:rgba(0, 0, 0, 54%)">
                                <div class="mr-3 mt-3 position-absolute topDogRankIcon" [ngClass]="participantsInfo[1].results"
                                     style="width:47px; height:87px; background-size:47px; background-repeat:no-repeat; background-position:center; right:0; top:0"></div>
                                <img class="mr-3" style="height:87px; border-radius:50%" [src]="'../Admin/ImageResizer.aspx?imgid=' + (participantsInfo[1].ImageID || '-2') + '&w=auto&h=87'" />
                                <div class="font-size-36 text-truncate">{{participantsInfo[1].participant.LoginName}}</div>

                                <div class="row justify-content-center align-items-center">
                                    <div class="col-6 text-center font-size-24">{{selectedGame[0].SelectedMetrics[0].name}}</div>
                                    <div class="col-6 font-size-36 text-center">{{participantsInfo[1].metric}}</div>
                                </div>

                                <div class="py-3">
                                    <div class="d-flex justify-content-between text-center" style="margin:0 20px">
                                        <div class="text-center">
                                            <svg class="d-block my-0 mx-auto" style="width:35px; height:35px; fill:#fff"><use href="../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use></svg>
                                            <span class="font-size-32">{{participantsInfo[1].calculatedCoins}}</span>
                                        </div>

                                        <div class="text-center">
                                            <svg class="d-block my-0 mx-auto" style="width:35px; height:35px; fill:#fff"><use href="../App_Themes/clearview-default/icons/utility/xp.svg#xp"></use></svg>
                                            <div class="font-size-32">{{participantsInfo[1].calculatedXP}}</div>
                                        </div>

                                        <div class="text-center">
                                            <div class="d-flex align-items-center" *ngIf="participantsInfo[1].badges && participantsInfo[1].badges.length > 0">
                                                <img class="img-fluid" [src]="'../Admin/ImageResizer.aspx?imgid=' + participantsInfo[1].badges[0] + '&w=60&h=60'" />
                                            </div>

                                            <div [hidden]="participantsInfo[1].badges && participantsInfo[1].badges.length > 0">
                                                <svg class="d-block my-0 mx-auto" style="width:35px; height:35px; fill:#fff"><use href="../App_Themes/clearview-default/icons/utility/badge.svg#badge"></use></svg>
                                                <span style="font-size:32px">---</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-4">
                            <div class="px-1 w-100 text-center pt-5 position-relative" style="background-color:rgba(0, 0, 0, 54%)">
                                <div class="mr-3 mt-3 position-absolute topDogRankIcon" [ngClass]="participantsInfo[0].results"
                                     style="width:60px; height:111px; background-size:60px; background-repeat:no-repeat; background-position:center; right:0; top:0"></div>
                                <img class="mr-3" style="height:118px; border-radius:50%" [src]="'../Admin/ImageResizer.aspx?imgid=' + (participantsInfo[0].ImageID || '-2') + '&w=auto&h=118'" />
                                <div class="font-size-36 text-truncate">{{participantsInfo[0].participant.LoginName}}</div>

                                <div class="row justify-content-center align-items-center">
                                    <div class="col-6 text-center font-size-24">{{selectedGame[0].SelectedMetrics[0].name}}</div>
                                    <div class="col-6 font-size-36 text-center">{{participantsInfo[0].metric}}</div>
                                </div>

                                <div class="py-3">
                                    <div class="d-flex justify-content-between text-center" style="margin:0 20px">
                                        <div class="text-center">
                                            <svg class="d-block my-0 mx-auto" style="width:35px; height:35px; fill:#fff"><use href="../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use></svg>
                                            <span class="font-size-32">{{participantsInfo[0].calculatedCoins}}</span>
                                        </div>

                                        <div class="text-center">
                                            <svg class="d-block my-0 mx-auto" style="width:35px; height:35px; fill:#fff"><use href="../App_Themes/clearview-default/icons/utility/xp.svg#xp"></use></svg>
                                            <div class="font-size-32">{{participantsInfo[0].calculatedXP}}</div>
                                        </div>

                                        <div class="text-center">
                                            <div class="d-flex align-items-center" *ngIf="participantsInfo[0].badges && participantsInfo[0].badges.length > 0">
                                                <img class="img-fluid" [src]="'../Admin/ImageResizer.aspx?imgid=' + participantsInfo[0].badges[0] + '&w=60&h=60'" />
                                            </div>

                                            <div [hidden]="participantsInfo[0].badges && participantsInfo[0].badges.length > 0">
                                                <svg class="d-block my-0 mx-auto" style="width:35px; height:35px; fill:#fff"><use href="../App_Themes/clearview-default/icons/utility/badge.svg#badge"></use></svg>
                                                <span style="font-size: 32px">---</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-4" style="padding-top:65px">
                            <div class="px-1 w-100 text-center pt-3 position-relative" style="background-color:rgba(0, 0, 0, 54%)">
                                <div class="mr-3 mt-3 position-absolute topDogRankIcon" [ngClass]="participantsInfo[2].results"
                                     style="width:47px; height:87px; background-size:47px; background-repeat:no-repeat; background-position:center; top:0; right:0"></div>
                                <img class="mr-3" style="height:87px; border-radius:50%" [src]="'../Admin/ImageResizer.aspx?imgid=' + (participantsInfo[2].ImageID || '-2') + '&w=auto&h=87'" />
                                <div class="font-size-36 text-truncate">{{participantsInfo[2].participant.LoginName}}</div>

                                <div class="row justify-content-center align-items-center">
                                    <div class="col-6 text-center font-size-24">{{selectedGame[0].SelectedMetrics[0].name}}</div>
                                    <div class="col-6 font-size-36 text-center">{{participantsInfo[2].metric}}</div>
                                </div>

                                <div class="py-3">
                                    <div class="d-flex justify-content-between text-center" style="margin:0 20px">
                                        <div class="text-center">
                                            <svg class="d-block my-0 mx-auto" style="width:35px; height:35px; fill:#fff"><use href="../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use></svg>
                                            <span class="font-size-32">{{participantsInfo[2].calculatedCoins}}</span>
                                        </div>

                                        <div class="text-center">
                                            <svg class="d-block my-0 mx-auto" style="width:35px; height:35px; fill:#fff"><use href="../App_Themes/clearview-default/icons/utility/xp.svg#xp"></use></svg>
                                            <div class="font-size-32">{{ participantsInfo[2].calculatedXP }}</div>
                                        </div>

                                        <div class="text-center">
                                            <div class="d-flex align-items-center" *ngIf="participantsInfo[2].badges && participantsInfo[2].badges.length > 0">
                                                <img class="img-fluid" [src]="'../Admin/ImageResizer.aspx?imgid=' + participantsInfo[2].badges[0] + '&w=60&h=60'" />
                                            </div>

                                            <div [hidden]="participantsInfo[2].badges && participantsInfo[2].badges.length > 0">
                                                <svg class="d-block my-0 mx-auto" style="width:35px; height:35px; fill:#fff"><use href="../App_Themes/clearview-default/icons/utility/badge.svg#badge"></use></svg>
                                                <span style="font-size: 32px">---</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 pt-5">
                <div class="d-flex row">
                    <div class="col-7 font-size-24">Agents</div>
                    <div class="col-2 font-size-24 text-center">{{selectedGame[0].SelectedMetrics[0].name}}</div>
                    <div class="col-1 font-size-24 text-center">Coins</div>
                    <div class="col-1 font-size-24 text-center">XP</div>
                    <div class="col-1 font-size-24 text-center">Badge</div>
                </div>

                <div class="row py-3" *ngFor="let participantObject of participantsInfo | startOn: 3 | limitTo: 2">
                    <div class="col-7 d-flex font-size-18">
                        <div class="topDogRankIcon" [ngClass]="participantObject.results"
                             style="width:30px; height:60px; margin-right:15px; background-size:30px; background-repeat:no-repeat; background-position:center"></div>
                        <img class="mr-3" style="height:55px; border-radius:50%" [src]="participantObject.ImageSrc" />
                        <div class="font-size-36 text-truncate">{{participantObject.participant.LoginName}}</div>
                    </div>

                    <div class="col-2 font-size-36 text-center">{{participantObject.metric}}</div>
                    <div class="col-1 font-size-36 text-center text-truncate">{{participantObject.calculatedCoins}}</div>
                    <div class="col-1 font-size-36 text-center text-truncate">{{participantObject.calculatedXP}}</div>

                    <div class="col-1 font-size-36 text-center">
                        <div *ngIf="participantObject.badges && participantObject.badges.length > 0">
                            <img class="img-fluid" [src]="'../Admin/ImageResizer.aspx?imgid=' + participantObject.badges[0] + '&w=60&h=60'" />
                        </div>

                        <div [hidden]="participantObject.badges && participantObject.badges.length > 0">---</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row px-4 mt-3 pt-4 text-left" style="border-radius:2px; background-color:rgba(0, 0, 0, 54%)"
             *ngIf="selectedGame[0]?.underlyingRule.GameType == 2 && gameState.DisplayOption == 1 && participantsInfo?.length > 0">
            <div class="col-12">
                <div class="row d-flex">
                    <div class="col-6 font-size-24">Agents</div>
                    <div class="col-1 font-size-24 text-center">{{selectedGame[0].Qualifier ? selectedGame[0].Qualifier.abbrev : ''}}</div>
                    <div class="col-2 font-size-24 text-center">{{selectedGame[0].SelectedMetrics[0].name}}</div>
                    <div class="col-1 font-size-24 text-center">Coins</div>
                    <div class="col-1 font-size-24 text-center">XP</div>
                    <div class="col-1 font-size-24 text-center">Badge</div>
                </div>

                <div class="row py-3" [ngStyle]="last == false && { 'border-bottom' : '1px solid white' }" *ngFor="let participantObject of participantsInfo | startOn: 0 | limitTo: 5; let last = last">
                    <div class="col-6 d-flex font-size-18">
                        <div class="topDogRankIcon" [ngClass]="participantObject.results"
                             style="width:30px; height:60px; margin-right:15px; background-size:30px; background-repeat:no-repeat; background-position:center"></div>
                        <img class="mr-3" style="height:55px; border-radius:50%; border:1px solid white" [src]="participantObject.ImageSrc" />
                        <div class="font-size-36 text-truncate">{{participantObject.participant.LoginName}}</div>
                    </div>

                    <div class="col-1 text-center d-flex justify-content-center align-items-center">
                        <div *ngIf="selectedGame[0].Qualifier">
                            <svg class="icon-32 fill-white" *ngIf="participantObject.passed"><use href="../App_Themes/clearview-default/icons/utility/checkmark.svg#checkmark"></use></svg>
                            <svg *ngIf="!participantObject.passed" class="icon-32 fill-redRyder"><use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use></svg>
                        </div>
                    </div>

                    <div class="col-2 font-size-36 text-center">{{participantObject.metric}}</div>
                    <div class="col-1 font-size-36 text-center text-truncate">{{participantObject.calculatedCoins}}</div>
                    <div class="col-1 font-size-36 text-center text-truncate">{{participantObject.calculatedXP}}</div>
                    <div class="col-1 font-size-36 text-center">
                        <div *ngIf="participantObject.badges && participantObject.badges.length > 0">
                            <img class="img-fluid" [src]="'../Admin/ImageResizer.aspx?imgid=' + participantObject.badges[0] + '&w=60&h=60'" />
                        </div>

                        <div [hidden]="participantObject.badges && participantObject.badges.length > 0">---</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- END Table Top Dog -->
        <!-- Bullseye Template -->
        <div class="row py-3 justify-content-around" style="border-radius:2px" *ngIf="selectedGame[0]?.underlyingRule.GameType == 3 && !isSlideDataLoading">
            <div class="pt-4 pb-2" style="background-color:rgba(0, 0, 0, 54%); min-width:260px; width:320px" *ngFor="let bullseyeReward of selectedGame[0].BullseyeRewards; let $index = index">
                <div class="bullseyeTargetIcon tier1 d-block my-0 mx-auto" style="width:112px; height:129px; background-size:112px; background-position:center" *ngIf="$index == 0"></div>
                <div class="bullseyeTargetIcon tier2 d-block my-0 mx-auto" style="width:112px; height:129px; background-size:112px; background-position:center" *ngIf="$index == 1"></div>
                <div class="bullseyeTargetIcon tier3 d-block my-0 mx-auto" style="width:112px; height:129px; background-size:112px; background-position:center" *ngIf="$index == 2"></div>
                <div class="bullseyeTargetIcon tier4 d-block my-0 mx-auto" style="width:112px; height:129px; background-size:112px; background-position:center" *ngIf="$index == 3"></div>
                <div class="bullseyeTargetIcon tier5 d-block my-0 mx-auto" style="width:112px; height:129px; background-size:112px; background-position:center" *ngIf="$index == 4"></div>

                <div>
                    <div class="text-center font-size-24" *ngIf="$index == 0"><span cvLocalizedText langSection="Games_Module" langKey="Bullseye_Prize">Bullseye Prize</span></div>
                    <div class="text-center font-size-24" *ngIf="$index == 1"><span cvLocalizedText langSection="Games_Module" langKey="2nd_Ring">2nd Ring Prize</span></div>
                    <div class="text-center font-size-24" *ngIf="$index == 2"><span cvLocalizedText langSection="Games_Module" langKey="3rd_Ring">3rd Ring Prize</span></div>
                    <div class="text-center font-size-24" *ngIf="$index > 2">
                        {{$index +1 }}<span cvLocalizedText lang_section="Games_Module" lang_key="Th_Symbol">th</span>&nbsp;<span cvLocalizedText langSection="Games_Module" langKey="Ring">Ring Prize</span>
                    </div>
                </div>

                <div class="text-center font-size-24" style="height:64px; padding-top:10px">
                    <span *ngIf="bullseyeReward.ComparisonType == '1'" cvLocalizedText langSection="Games" langKey="Greater_Than">Greater Than</span>
                    <span *ngIf="bullseyeReward.ComparisonType == '2'" cvLocalizedText langSection="Games" langKey="Less_Than">Less Than</span>
                    <span *ngIf="bullseyeReward.ComparisonType == '3'" cvLocalizedText langSection="Games" langKey="Between">Between</span>
                    <span>{{formatterMetricData(selectedGame[0].Qualifier?.conversionType, bullseyeReward.Target.Val1)}}</span><br />
                    <span *ngIf="bullseyeReward.ComparisonType == 3" class="align-self-center mx-2" cvLocalizedText langSection="Games_Module" langKey="And">and</span>
                    <span *ngIf="bullseyeReward.ComparisonType == 3">{{formatterMetricData(selectedGame[0].Qualifier?.conversionType, bullseyeReward.Target.Val2)}}</span>
                </div>

                <div style="padding:25px 0">
                    <div class="row justify-content-between text-truncate">
                        <div class="col-4 text-center">
                            <svg class="d-block my-0 mx-auto" style="width:35px; height:35px; fill:#fff"><use href="../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use></svg>
                            <span style="font-size:32px">{{(selectedGame[0].BullseyeRewards[$index].Coins != null) ? selectedGame[0].BullseyeRewards[$index].Coins.rewardValue : "---"}}</span>
                        </div>

                        <div class="col-4 text-center">
                            <svg class="d-block my-0 mx-auto" style="width:35px; height:35px; fill:#fff"><use href="../App_Themes/clearview-default/icons/utility/xp.svg#xp"></use></svg>
                            <span style="font-size: 32px">{{(selectedGame[0].BullseyeRewards[$index].XP != null) ? selectedGame[0].BullseyeRewards[$index].XP.rewardValue : "---"}}</span>
                        </div>

                        <div class="col-4 text-center">
                            <div class="d-flex align-items-center" *ngIf="getBadgeUsingIndex(selectedGame[0],$index) != null">
                                <img [src]="getBadgeUsingIndex(selectedGame[0],$index)" />
                            </div>

                            <div *ngIf="getBadgeUsingIndex(selectedGame[0],$index) == null">
                                <svg class="d-block my-0 mx-auto" style="width:35px; height:35px; fill:#fff"><use href="../App_Themes/clearview-default/icons/utility/badge.svg#badge"></use></svg>
                                <span style="font-size: 32px">---</span>
                            </div>
                        </div>
                    </div>
                </div>

                <hr class="my-0 mx-auto" style="width:88%; border-top:1px solid white" />

                <div class="d-flex font-size-36 text-center" style="max-width:320px; min-height:365px" *ngIf="!(bullseyeWinners[$index].length > 0)">
                    <div class="align-self-center">No players to show. Check back later.</div>
                </div>

                <div class="p-2 text-truncate" style="max-width:320px" *ngIf="bullseyeWinners[$index].length > 0 && gameState.DisplayOption == 0">
                    <div class="d-flex" style="max-width:320px; padding-top:10px" *ngFor="let participantObject of bullseyeWinners[$index] | startOn: currentPage*pageSize:totalPages > 0 | limitTo: pageSize">
                        <img class="mr-3" [src]="participantObject.ImageSrc" style="height:55px; border-radius:50%">
                        <div class="text-truncate" style="font-size:40px; padding-left:10px">{{participantObject.participant.LoginName}}</div>
                    </div>
                </div>

                <div class="text-center w-100" style="padding-top:65px; padding-bottom:77px; max-width:320px" *ngIf="bullseyeWinners[$index].length > 0 && gameState.DisplayOption == 1">
                    <div *ngIf="bullseyeWinners[$index].length > 0">
                        <div style="font-size:113px">{{bullseyeWinners[$index].length > 0 ? bullseyeWinners[$index].length : '00'}}</div>
                        <div style="font-size:53px">Players</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row py-3 mt-3 align-items-center justify-content-center text-left flex-column" style="border-radius:2px; background-color:rgba(0, 0, 0, 54%); height:80%"
            *ngIf="(selectedGame[0]?.underlyingRule.GameType == 3 || selectedGame[0]?.underlyingRule.GameType == 5) && (participantsInfo == null || participantsInfo?.length == 0) && isSlideDataLoading">
            <div *ngIf="isSlideDataLoading">
                <div class="font-size-24">Just a moment, we are loading your game stats</div>
            </div>
        </div>

        <!-- END Bullseye Template -->
        <!-- Table Connect 3 -->
        <div class="row" style="background-color:rgba(0, 0, 0, 54%); border-top-left-radius:2px; border-top-right-radius:2px"
            *ngIf="(selectedGame[0]?.underlyingRule.GameType == 6 || selectedGame[0]?.underlyingRule.GameType == 7) && gameState.DisplayOption == 0">
            <div class="col-12">
                <hr class="my-0 mx-auto" style="border-top:1px white solid; width:98%">
            </div>
        </div>

        <div class="row" style="border-radius:2px; background-color:rgba(0, 0, 0, 54%); height:85%"
            *ngIf="(selectedGame[0]?.underlyingRule.GameType == 6 || selectedGame[0]?.underlyingRule.GameType == 7) && gameState.DisplayOption == 0 && participantsInfo?.length > 0">
            <div class="col-8">
                <div class="row">
                    <div class="col-6 row font-size-18 pt-4" *ngFor="let participantObject of participantsInfo | startOn: currentPage*pageSize:totalPages > 0 | limitTo: pageSize">
                        <div class="col-10 d-flex">
                            <img class="mr-3" style="height:55px; border-radius:50%" [src]="participantObject.ImageSrc" />
                            <div class="text-truncate" style="font-size:40px">{{participantObject.participant.LoginName}}</div>
                        </div>

                        <div class="col-2">
                            <!-- Connect3 - results display Metrics -->
                            <div class="row" style="width:58px; height:58px">
                                <div style="width:15px; height:16px; margin:1px" *ngFor="let metricPosition of selectedGame[0].Connect3Positions">
                                    <div class="rounded-sm" [ngClass]="participantObject.connect3Metrics[metricPosition.position].metricCompleted ? 'bg-white'  : 'bg-inversion opacity-50'" style="height:15px"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-4 justify-content-center align-self-center">
                <!-- Connect3 - Display Metrics -->
                <div class="row p-2" style="max-width: 512px" *ngIf="selectedGame[0]?.underlyingRule.GameType == 6 || selectedGame[0]?.underlyingRule.GameType == 7">
                    <div class="col-4" *ngFor="let metricPosition of selectedGame[0].Connect3Positions">
                        <div class="card p-2 mx-n2 my-2 text-center font-size-18" [ngClass]="getConnect3Class(metricPosition, selectedGame[0]?.underlyingRule.GameType)" style="height:150px">
                            <div class="d-flex flex-column justify-content-center align-items-center h-100">
                                <div class="metric-container" style="text-shadow:none">
                                    <div *ngIf="metricPosition.metric == null">
                                        <svg class="icon-16 fill-valyrianSteel"><use href="../App_Themes/clearview-default/icons/utility/add.svg#add"></use></svg>
                                    </div>

                                    <div class="font-size-20">{{(metricPosition.metric == null) ? "Metric Goal" : metricPosition.metric.abbrev}}</div>
                                    <div class="font-size-20" *ngIf="!!metricPosition.targetObj?.Target">
                                        {{(metricPosition.metric.direction === "0")?"<":">"}}
                                        {{formatterMetricData(metricPosition.metric?.conversionType,metricPosition.targetObj.Target)}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row h-100" style="border-radius:2px" *ngIf="(selectedGame[0]?.underlyingRule.GameType == 6 || selectedGame[0]?.underlyingRule.GameType == 7) && gameState.DisplayOption == 1">
            <div class="col-4 justify-content-center align-self-center">
                <div class="px-2 py-3 my-0 mx-auto" style="background-color:rgba(0, 0, 0, 54%); width:303px; height:830px">
                    <div class="row py-3">
                        <div class="col-12 align-items-center justify-content-center text-center">
                            <div class="my-0 mx-auto" [ngClass]="selectedGame[0].iconClass" title="{{selectedGame[0].gameTypeName}}"
                                 style="width:99px; height:80px; background-size:80px; background-repeat:no-repeat"></div>

                            <div class="font-size-32 pl-3 text-truncate">
                                <span>{{selectedGame[0]?.underlyingRule.RuleName}}</span><br />
                                <svg class="font-size-24" style="width:19px; height:19px; fill:#fff"><use href="../App_Themes/clearview-default/icons/utility/time.svg#time"></use></svg>
                                <span class="font-size-24">{{selectedGame[0].isActiveText}}</span>
                            </div>
                        </div>
                    </div>

                    <hr class="border-bottom my-0 mx-auto" style="width:90%" />

                    <div class="row py-3">
                        <div class="col-12">
                            <div class="text-center font-size-24">
                                <span *ngIf="selectedGame[0]?.underlyingRule.GameType == 6 || selectedGame[0]?.underlyingRule.GameType == 7">3-of-a-row Reward</span>
                            </div>

                            <div class="w-100 justify-content-between">
                                <div class="d-flex justify-content-center align-items-center font-size-36 py-1">
                                    <svg class="fill-white mr-2" style="width:40px; height:40px"><use href="../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use></svg>
                                    <span *ngIf="selectedGame[0]?.underlyingRule.GameType == 6">{{selectedGame[0].Connect3Rewards.ThreeInRow.coins}}</span>
                                    <span *ngIf="selectedGame[0]?.underlyingRule.GameType == 7">{{selectedGame[0].Connect3Rewards.Blackout.coins}}</span>
                                </div>

                                <div class="d-flex justify-content-center align-items-center font-size-36 py-1">
                                    <svg class="fill-white mr-2" style="width:40px; height:40px"><use href="../App_Themes/clearview-default/icons/utility/xp.svg#xp"></use></svg>
                                    <span *ngIf="selectedGame[0]?.underlyingRule.GameType == 6">{{selectedGame[0].Connect3Rewards.ThreeInRow.xp}}</span>
                                    <span *ngIf="selectedGame[0]?.underlyingRule.GameType == 7">{{selectedGame[0].Connect3Rewards.Blackout.xp}}</span>
                                </div>

                                <div class="d-flex justify-content-center align-items-center py-1" *ngIf="selectedGame[0]?.underlyingRule.GameType != 1">
                                    <div *ngIf="selectedGame[0]?.underlyingRule.GameType == 6">
                                        <img *ngIf="selectedGame[0].Connect3Rewards.ThreeInRow.badge > 0"
                                             [src]="'../Admin/ImageResizer.aspx?imgid='+ selectedGame[0].Connect3Rewards.ThreeInRow.badge +'&w=60&h=60'" />

                                        <div class="d-flex justify-content-center align-items-center" *ngIf="!(selectedGame[0].Connect3Rewards.ThreeInRow.badge > 0)">
                                            <svg class="fill-white mr-2" style="width:40px; height:40px"><use href="../App_Themes/clearview-default/icons/utility/badge.svg#badge"></use></svg>
                                            <span class="font-size-36">---</span>
                                        </div>
                                    </div>

                                    <div *ngIf="selectedGame[0]?.underlyingRule.GameType == 7">
                                        <img *ngIf="selectedGame[0].Connect3Rewards.Blackout.badge > 0"
                                             [src]="'../Admin/ImageResizer.aspx?imgid='+ selectedGame[0].Connect3Rewards.Blackout.badge +'&w=60&h=60'" />

                                        <div class="d-flex justify-content-center align-items-center" *ngIf="!(selectedGame[0].Connect3Rewards.Blackout.badge > 0)">
                                            <svg class="fill-white mr-2" style="width:40px; height:40px; fill:#fff"><use href="../App_Themes/clearview-default/icons/utility/badge.svg#badge"></use></svg>
                                            <span class="font-size-36">---</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <hr class="border-bottom my-0 mx-auto" style="width:90%" />

                    <div class="row py-3">
                        <div class="col-12 align-items-center justify-content-between">
                            <div class="text-center py-1">
                                <div class="font-size-24">Metric</div>
                                <div class="font-size-36" style="line-height:1" *ngIf="selectedGame[0]?.underlyingRule.GameType != 6 && selectedGame[0]?.underlyingRule.GameType != 7">
                                    {{selectedGame[0].SelectedMetrics[0].abbrev}}
                                </div>

                                <div class="font-size-36" style="line-height:1" *ngIf="selectedGame[0]?.underlyingRule.GameType == 6 || selectedGame[0]?.underlyingRule.GameType == 7">
                                    {{selectedGame[0].SelectedMetrics.length}}
                                </div>
                            </div>

                            <div class="text-center py-1">
                                <div class="font-size-24">Qualifier</div>
                                <div class="font-size-36" style="line-height: 1">{{selectedGame[0].Qualifier ? selectedGame[0].Qualifier.abbrev : 'None'}}</div>
                            </div>
                        </div>
                    </div>

                    <hr class="border-bottom my-0 mx-auto" style="width:90%" />

                    <div class="row py-4">
                        <div class="col-12 text-center d-block align-items-center">
                            <div class="font-size-24">Join Players</div>
                            <div class="font-size-36">{{totalJoinedParticipants}} / {{totalParticipants}}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-8 justify-content-center align-self-center">
                <!-- Connect3 - Display Metrics -->
                <div class="row p-2" style="max-width:830px; background-color:rgba(0, 0, 0, 54%)"
                     *ngIf="(selectedGame[0]?.underlyingRule.GameType == 6 || selectedGame[0]?.underlyingRule.GameType == 7) && participantsInfo?.length > 0">
                    <div class="col-4" *ngFor="let metricPosition of selectedGame[0].Connect3Positions">
                        <div class="card p-2 mx-n2 my-2 text-center font-size-18" [ngClass]="getConnect3Class(metricPosition, selectedGame[0]?.underlyingRule.GameType)" style="height:255px">
                            <div class="d-flex flex-column justify-content-center align-items-center h-100">
                                <div class="metric-container" style="text-shadow:none">
                                    <div *ngIf="metricPosition.metric == null">
                                        <svg class="icon-16 fill-valyrianSteel"><use href="../App_Themes/clearview-default/icons/utility/add.svg#add"></use></svg>
                                    </div>

                                    <div class="font-size-28">{{(metricPosition.metric == null)? "Metric Goal" : metricPosition.metric.abbrev}}</div>
                                    <div class="font-size-28" *ngIf="!!metricPosition.targetObj?.Target">
                                        {{(metricPosition.metric.direction === "0")?"<":">"}}
                                        {{formatterMetricData(metricPosition.metric?.conversionType,metricPosition.targetObj.Target)}}
                                    </div>

                                    <div *ngIf="metricPosition.metric.metricID > -1">
                                        <div class="font-size-48">{{metricPosition.numberOfAgents ? metricPosition.numberOfAgents : '00'}}</div>
                                        <div class="font-size-28">Agents</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Empty State for Connect3 and ConnectAll Total agents template (DisplayOption 1)-->
                <div class="row p-2 align-items-center justify-content-center h-100" style="max-width:830px; background-color:rgba(0, 0, 0, 54%)"
                    *ngIf="(selectedGame[0]?.underlyingRule.GameType == 6 || selectedGame[0]?.underlyingRule.GameType == 7) && gameState.DisplayOption == 1 && (participantsInfo == null || participantsInfo?.length == 0)">
                    <div *ngIf="isSlideDataLoading">
                        <div class="font-size-24">Just a moment, we are loading your game stats</div>
                    </div>

                    <div [hidden]="isSlideDataLoading">
                        <div class="font-size-24">No players to show.</div>
                        <div class="font-size-24">Check back later.</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- END Table Connect3 -->
        <!-- Empty State for Connect3 and ConnectAll -->
        <div class="row align-items-center justify-content-center text-left flex-column" style="border-radius: 2px; background-color:rgba(0, 0, 0, 54%); height:80%;"
            *ngIf="(selectedGame[0]?.underlyingRule.GameType == 6 || selectedGame[0]?.underlyingRule.GameType == 7) && gameState.DisplayOption == 0 && (participantsInfo == null || participantsInfo?.length == 0)">
            <div *ngIf="isSlideDataLoading">
                <div class="font-size-24">Just a moment, we are loading your game stats</div>
            </div>

            <div [hidden]="isSlideDataLoading">
                <div class="font-size-24">No players to show.</div>
                <div class="font-size-24">Check back later.</div>
            </div>
        </div>

        <!-- END Empty State -->
        <!-- Milestone Template -->
        <div class="row justify-content-around py-3" style="border-radius:2px" *ngIf="selectedGame[0]?.underlyingRule.GameType == 5 && !isSlideDataLoading">
            <div class="pt-4 pb-2" style="background-color:rgba(0, 0, 0, 54%); min-width:260px; width:320px"
                *ngFor="let MilestoneReward of selectedGame[0].MilestoneRewards | orderBy:'milestoneReward':true; let $index = index">
                <!--[ngClass]="isWinner(selectedGame[0]?.underlyingRule.GameType,$index).toString()">-->

                <div class="tier1 my-0 mx-auto d-block" [ngStyle]="getCheckmark($index)" style="width:112px; height:129px; background-size:112px; background-repeat:no-repeat; background-position:center"></div>

                <div>
                    <div class="font-size-24 text-center"><span class="text-white">Milestone {{$index + 1}} Prize</span></div>
                </div>

                <div class="text-center font-size-24" style="height:64px; padding-top:10px">
                    <span *ngIf="MilestoneReward.ComparisonType == '1'" cvLocalizedText langSection="Games" langKey="Greater_Than">Greater Than</span>
                    <span *ngIf="MilestoneReward.ComparisonType == '2'" cvLocalizedText langSection="Games" langKey="Less_Than">Less Than</span>
                    <span *ngIf="MilestoneReward.ComparisonType == '3'" cvLocalizedText langSection="Games" langKey="Between">Between</span>

                    <span>{{formatterMetricData(selectedGame[0].Qualifier?.conversionType, MilestoneReward.Target.Val1)}}</span><br />
                    <span *ngIf="MilestoneReward.ComparisonType == 3" class="align-self-center mx-2" cvLocalizedText langSection="Games_Module" langKey="And">and</span>
                    <span *ngIf="MilestoneReward.ComparisonType == 3">{{formatterMetricData(selectedGame[0].Qualifier?.conversionType, MilestoneReward.Target.Val2)}}</span>
                </div>

                <div style="padding:25px 0">
                    <div class="row justify-content-between">
                        <div class="col-4 text-center">
                            <svg class="my-0 mx-auto d-block" style="width:35px; height:35px; fill:#fff"><use href="../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use></svg>
                            <span class="font-size-32">{{(selectedGame[0].MilestoneRewards[$index].Coins != null) ? selectedGame[0].MilestoneRewards[$index].Coins.rewardValue : "---"}}</span>
                        </div>

                        <div class="col-4 text-center">
                            <svg class="my-0 mx-auto d-block" style="width:35px; height:35px; fill:#fff"><use href="../App_Themes/clearview-default/icons/utility/xp.svg#xp"></use></svg>
                            <div class="font-size-32">{{(selectedGame[0].MilestoneRewards[$index].XP != null) ? selectedGame[0].MilestoneRewards[$index].XP.rewardValue : "---"}}</div>
                        </div>

                        <div class="col-4 text-center">
                            <div class="d-flex align-items-center" *ngIf="!!getBadgeUsingIndex(selectedGame[0],$index)">
                                <img [src]="getBadgeUsingIndex(selectedGame[0],$index)" />
                            </div>

                            <div *ngIf="!getBadgeUsingIndex(selectedGame[0],$index)">
                                <svg class="my-0 mx-auto d-block" style="width:35px; height:35px; fill:#fff"><use href="../App_Themes/clearview-default/icons/utility/badge.svg#badge"></use></svg>
                                <span style="font-size: 32px">---</span>
                            </div>
                        </div>
                    </div>
                </div>

                <hr class="my-0 mx-auto" style="width:88%; border-top:1px solid white" />

                <div class="d-flex font-size-36 text-center" style="max-width:320px; min-height:365px" *ngIf="!(milestoneWinners[$index].length > 0)">
                    <div class="align-self-center">No players to show. Check back later.</div>
                </div>

                <div class="p-2 text-center" style="max-width:320px; min-height:365px" *ngIf="milestoneWinners[$index].length > 0 && gameState.DisplayOption == 0">
                    <ng-container *ngFor="let participantObject of milestoneWinners[$index] | startOn: currentPage*pageSize:totalPages > 0 | limitTo: pageSize; let $index = index">
                        <div class="d-flex" style="max-width:320px; padding-top:10px" *ngIf="$index < 5">
                            <img class="mr-3" style="height:55px; border-radius:50%" [src]="participantObject.ImageSrc" />
                            <div class="text-truncate" style="font-size:40px; padding-left:10px">{{participantObject.participant.LoginName}}</div>
                        </div>
                    </ng-container>
                </div>

                <div class="text-center w-100" style="padding-top:65px; padding-bottom:77px; max-width:320px" *ngIf="milestoneWinners[$index].length > 0 && gameState.DisplayOption == 1">
                    <div style="font-size: 113px">{{milestoneWinners[$index].length > 0 ? milestoneWinners[$index].length : '00'}}</div>
                    <div style="font-size: 53px">Players</div>
                </div>
            </div>
        </div>
        <!-- END Milestone Template -->

        <div class="font-size-48 text-center px-2 position-absolute" style="bottom:50px; right:50px; min-width:120px; max-width:300px; height:80px; background-color:rgba(0, 0, 0, 54%)" *ngIf="totalPages > 0">
            {{(currentPage + 1) + "/" + totalPages}}
        </div>
    </div>
</div>
